import React from "react"
import styles from "./CustomTags.scss"
import { ReactComponent as CloseIcon } from "./assets/img/close-icon.svg"

export default class CustomTags extends React.Component {
  constructor(props) {
    super(props);
    this.addedKeys = [
      'remove',
      'inChange',
      'newTag',
      'ref',
      'editable'
    ];
    this.state = {
      tags: []
    }
  }

  removeAddedKeys = () => {
    return new Promise((resolve, reject) => {
      let { tags } = this.state;

      let returnTags = tags.map(val => {
        let currentVal = {}
        for (let [key, inVal] of Object.entries(val)) {
          if (!this.addedKeys.includes(key)) {
            currentVal[key] = inVal
          }
        }

        return currentVal
      });

      resolve(returnTags);
    })
  }

  componentDidMount() {
    let tags = []
    if (this.props.initialValue && this.props.initialValue.length) {
      tags = this.props.initialValue.map(val => {
        let currentVal = val

        currentVal.inChange = false
        currentVal.ref = React.createRef()
        currentVal.mainSpanRef = React.createRef()

        return currentVal
      })
    }
    this.setState({
      tags
    })
  }

  addNew = () => {
    let { tags } = this.state
    tags.push({
      value: 0,
      label: "",
      remove: true,
      inChange: true,
      newTag: true,
      ref: React.createRef(),
      mainSpanRef: React.createRef(),
      editable: true
    })

    this.setState({ tags }, () => {
      this.state.tags[this.state.tags.length - 1].ref.current.focus()
    })
  }

  changeDone = (index, callback) => {
    let { tags } = this.state

    tags[index].inChange = false;
    tags[index].newTag = false
    tags[index].label = tags[index].ref.current.innerText

    let checkTag = tags[index]

    if (!checkTag.label) {
      tags.splice(index, 1)
      this.setNewState(tags, callback)
    } else {
      if (checkTag) {
        let findLabelExists = this.state.tags.findIndex((val, findIndex) => {
          let label = val.label.toLowerCase()
          let checkLabel = checkTag.label.toLowerCase()

          if (label == checkLabel && index != findIndex) {
            return true
          } else {
            return false
          }
        })

        if (findLabelExists !== -1) {
          if (findLabelExists.value) {
            if (findLabelExists.value != checkTag.value) {
              tags[index].mainSpanRef.current.classList.add(styles.error)
              setTimeout(() => {
                tags[index].mainSpanRef.current.classList.remove(styles.error)
                tags.splice(index, 1)
                this.setNewState(tags, callback)
              }, 1500)
            }
          } else {
            tags[index].mainSpanRef.current.classList.add(styles.error)
            setTimeout(() => {
              tags[index].mainSpanRef.current.classList.remove(styles.error)
              tags.splice(index, 1)
              this.setNewState(tags, callback)
            }, 1500)
          }
        } else {
          if (this.props.validation) {
            let value = checkTag.label
            let validate = value.match(this.props.validation)
            if (!validate) {
              tags[index].mainSpanRef.current.classList.add(styles.error)
              setTimeout(() => {
                tags[index].mainSpanRef.current.classList.remove(styles.error)
                tags.splice(index, 1)
                this.setNewState(tags, callback)
              }, 1500)
            } else {
              this.setNewState(tags, callback)
            }
          } else {
            this.setNewState(tags, callback)
          }
        }
      }
    }
  }

  setNewState = (tags, callback) => {
    this.setState({ tags }, () => {
      this.removeAddedKeys().then(data => {
        this.props.onChange ? this.props.onChange(data) : null
      })
      if (callback) {
        callback()
      }
    })
  }

  onChange = (value, index) => {
    let { tags } = this.state
    tags[index].label = value

    this.setState({ tags })
  }

  startChange = (index) => {
    let { tags } = this.state

    tags[index].inChange = true

    this.setState({ tags })
  }

  showAdd = () => {
    let button = null
    let inProgress = this.state.tags.find(val => val.inChange == true)
    if (!inProgress) {
      button = <button
        className={styles.btn + " " + styles.btnSecondary + " " + styles.addNew}
        style={{ color: this.props.addBtnColor ? this.props.addBtnColor : styles.addNew.color }}
        onClick={() => {
          this.addNew()
        }}
      >
        {this.props.addNewText ? this.props.addNewText : "+ Add New"}
      </button>
    }

    return button
  }

  removeTag = (index) => {
    let { tags } = this.state

    tags[index].mainSpanRef.current.classList.add(styles.remove)
    setTimeout(() => {
      tags[index].mainSpanRef.current.classList.remove(styles.remove)
      tags.splice(index, 1)

      this.setState({ tags }, () => {
        this.removeAddedKeys().then(data => {
          this.props.onChange ? this.props.onChange(this.state.tags) : null
        })
      })
    }, 1500)
  }

  render() {
    return (
      <div className={styles.tagsMain}>
        {
          this.state.tags.map((val, index) => {
            return (
              <span className={styles.box} key={index}
                style={{
                  backgroundColor: this.props.tagColor ? this.props.tagColor : styles.tagValue["backgound-color"]
                }}
                ref={ref => val.mainSpanRef.current = ref}
              >
                <p
                  id={`tag_${index}`}
                  contentEditable={val.editable && val.editable === true ? true : false}
                  suppressContentEditableWarning="true"
                  ref={ref => val.ref.current = ref}
                  className={styles.tagValue}
                  style={{
                    color: this.props.tagTextColor ? this.props.tagTextColor : styles.tagValue.color
                  }}
                  onKeyDown={e => {
                    if (e.key == "Tab" || e.key == "Enter") {
                      if (val.ref.current.innerText.length) {
                        e.nativeEvent.stopImmediatePropagation()
                        e.nativeEvent.preventDefault()

                        this.changeDone(index, this.addNew)
                      } else {
                        if (e.key == "Enter") {
                          val.ref.current.blur()
                        }
                      }
                    }
                    if (e.key == "Backspace") {
                      if (!val.ref.current.innerText.length) {
                        this.changeDone(index, () => {
                          let tags = this.state.tags;
                          if (tags[index - 1].editable) {
                            this.state.tags[this.state.tags.length - 1].ref.current.focus()
                            // this.setState({
                            //   tags
                            // }, () => {

                            //   let preTag = document.getElementById(`tag_${index - 1}`);

                            //   let prevRef = this.state.tags[index - 1].ref.current

                            //   let setpos = document.createRange()
                            //   let set = window.getSelection()

                            //   prevRef.innerText = prevRef.innerText + " "
                            //   setpos.setStart(preTag.childNodes[0], prevRef.innerText.length)
                            //   set.removeAllRanges();
                            //   set.addRange(setpos);

                            //   this.state.tags[this.state.tags.length - 1].ref.current.focus()
                            // })
                          }
                        })
                      }
                    }
                  }}
                  onClick={() => {
                    if (val.editable) {
                      this.startChange(index)
                    }
                  }}
                  onBlur={() => {
                    if (val.editable) {
                      this.changeDone(index)
                    }
                  }}
                  onPaste={(e) => {
                    e.nativeEvent.stopImmediatePropagation()
                    e.nativeEvent.preventDefault()
                    const text = e.clipboardData.getData('text/plain');
                    document.execCommand("insertHTML", false, text);
                  }}
                >
                  {val.label}
                </p>
                {
                  val.inChange ? (
                    null
                  ) : (
                    val.remove ? (
                      <button
                        className={styles.btn + " " + styles.tagValueRemove}
                        onClick={() => {
                          this.removeTag(index)
                        }}
                        style={{
                          color: this.props.closeColor ? this.props.closeColor : styles.tagValueRemove.color,
                          backgroundColor: this.props.closeBGColor ? this.props.closeBGColor : styles.tagValueRemove["backgound-color"]
                        }}
                      >
                        <CloseIcon className={styles.closeIcon} />
                      </button>
                    ) : null
                  )
                }
              </span>
            )
          })
        }
        {
          this.showAdd()
        }

      </div>
    )
  }
}